import React from 'react';
import { Link } from 'react-router-dom';
import { Wrench, Clock, Phone, CheckCircle } from 'lucide-react';

const SEOContent = () => {
  return (
    <section className="py-16 md:py-24 md:py-32 px-4 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <article className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6 text-center">
            Réparation téléphone Saint-Chamond - Votre réparateur téléphone de confiance
          </h2>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              <strong className="text-blue-600">Suro Phone</strong> est votre <strong>réparateur téléphone</strong> expert spécialisé dans la <strong>réparation téléphone Saint-Chamond</strong> et la <strong>réparation smartphone Saint-Étienne</strong>. Nous intervenons également à domicile dans toute la Loire (42) : <span className="font-semibold">Rive-de-Gier, L'Horme, La Grand-Croix, Saint-Paul-en-Jarez, Génilac, Sorbiers, Firminy, Montbrison, Roanne</span> et bien d'autres — <Link to="/zones-intervention" className="text-blue-600 font-semibold hover:underline">voir toutes les communes desservies</Link>. En tant que <strong>réparateur téléphone autour de Saint-Chamond</strong>, nous sommes reconnus pour notre expertise en <strong>réparation iPhone Saint-Chamond</strong> et Samsung Galaxy.
            </p>

            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-lg mb-6">
              <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <Wrench className="w-6 h-6 text-blue-600" />
                Nous réparons tous types de pannes :
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3 text-gray-700">
                  <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" />
                  <span><strong>Écran cassé</strong> – Remplacement d'écran Premium, OLED ou Original pour iPhone et Samsung</span>
                </li>
                <li className="flex items-start gap-3 text-gray-700">
                  <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" />
                  <span><strong>Batterie qui se décharge</strong> – Changement de batterie haute capacité</span>
                </li>
                <li className="flex items-start gap-3 text-gray-700">
                  <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" />
                  <span><strong>Téléphone qui ne charge plus</strong> – Réparation du connecteur de charge</span>
                </li>
                <li className="flex items-start gap-3 text-gray-700">
                  <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" />
                  <span><strong>Caméra cassée</strong> – Remplacement de la caméra avant ou arrière</span>
                </li>
                <li className="flex items-start gap-3 text-gray-700">
                  <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" />
                  <span><strong>Téléphone tombé dans l'eau</strong> – Intervention rapide contre l'oxydation</span>
                </li>
              </ul>
            </div>

            <div className="bg-green-50 border-l-4 border-green-600 p-6 rounded-r-lg">
              <p className="text-lg text-gray-700 flex items-start gap-3">
                <Clock className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" />
                <span>
                  <strong className="text-green-700">La majorité des réparations sont réalisées le jour même.</strong> Nous intervenons rapidement pour que vous puissiez récupérer votre téléphone dans les plus brefs délais.
                </span>
              </p>
            </div>

            <div className="mt-8 pt-8 border-t border-gray-200 text-center">
              <p className="text-gray-600 mb-4">
                <Clock className="w-5 h-5 inline-block mr-2 text-blue-600" />
                <strong>Horaires :</strong> Lundi – vendredi 10h00 – 18h00, samedi 10h00 – 19h00, dimanche fermé <span className="text-blue-600 font-semibold">(sur rendez-vous uniquement)</span>
              </p>
              <p className="text-gray-600">
                <Phone className="w-5 h-5 inline-block mr-2 text-blue-600" />
                <strong>Téléphone :</strong> <a href="tel:0773601521" className="text-blue-600 hover:underline font-semibold">07.73.60.15.21</a>
              </p>
            </div>
          </div>
        </article>
      </div>
    </section>
  );
};

export default SEOContent;